import { clientConfigApi } from ".";
import { GetClientsListResponse } from "./client";

export type GetPartnersListResponse = { partnerId: string; name: string }[];

export const partnerApi = clientConfigApi.injectEndpoints({
  endpoints: (builder) => ({
    getPartnersList: builder.query<CustomDrawerContentType[], void>({
      query: () => {
        return {
          url: "/api/Partners",
          method: "GET"
        };
      },
      transformResponse: (
        response: GetPartnersListResponse
      ): CustomDrawerContentType[] => {
        return response.map((partnerData) => ({
          id: partnerData.partnerId,
          name: partnerData.name,
          salesforceId: ""
        }));
      },
      providesTags: ["partners"]
    }),
    getClientsListByPartner: builder.query<
      CustomDrawerContentType[],
      { partnerId: string }
    >({
      query: (data) => {
        const { partnerId } = data;
        return {
          url: `/api/Clients/${partnerId}`,
          method: "GET"
        };
      },
      transformResponse: (
        response: GetClientsListResponse
      ): CustomDrawerContentType[] => {
        return response.map((clientData) => ({
          id: clientData.clientId,
          name: clientData.name,
          salesforceId: clientData.salesForceId
        }));
      },
      providesTags: ["clients"]
    })
  }),
  overrideExisting: false
});

export const { useGetPartnersListQuery, useGetClientsListByPartnerQuery } =
  partnerApi;

export default partnerApi;
